const addZero = (i: number) => (i < 10 ? `0${i}` : i);

export default addZero;

export { addZero };
